import ShowerAlertsModalContainer from "./container/ShowerAlertsModalContainer";

export default ShowerAlertsModalContainer